import { DehydratedProject } from 'au-js-sdk/lib/models/Project';
import { ProductAttribute } from 'features/pdp';

//TODO hardcode correct page count
const projectAttributeExcludeList = ['design', 'mat', 'pages', 'page_count'];

export const getProjectInfo = (project: DehydratedProject, attributes: ProductAttribute[]): string => {
  if (!project?.product?.sku || !attributes?.length) {
    return '';
  }

  const projectAttributes = Object.keys(project.product.options)
    .filter(projectAttributeLabel => !projectAttributeExcludeList.includes(projectAttributeLabel))
    .map(projectAttributeLabel => {
      const projectAttributeOptionLabel = project.product.options[projectAttributeLabel];

      const productAttribute = attributes.find(a => a.label === projectAttributeLabel);
      if (!productAttribute) {
        return null;
      }

      const productAttributeOption = Array.isArray(productAttribute.options) 
        ? productAttribute.options.find(o => o.label === projectAttributeOptionLabel) 
        : null;
      if (!productAttributeOption) {
        return null;
      }

      return {
        attributeLabel: projectAttributeLabel,
        optionLabel: projectAttributeOptionLabel,
        displayName: productAttributeOption.display_name,
        priority: projectAttributePriorityMap[projectAttributeLabel]
      };
    });

  const sortedProjectAttributes = projectAttributes
    .filter(a => a?.displayName?.length > 0)
    .sort((a, b) =>
      (projectAttributePriorityMap[a.attributeLabel] || 0) >= (projectAttributePriorityMap[b.attributeLabel] || 0)
        ? -1
        : 1
    );

  const displayNames = sortedProjectAttributes.map(a => a.displayName);
  return displayNames.join(' • ');
};

//Used to order the display names for project info
//Higher number means first on the list
const projectAttributePriorityMap = {
  size: 100,
  album_size: 100,
  book_size: 100,
  box_size: 100,
  canvas_frame_size: 100,
  deep_frame_size: 100,
  float_frame_size: 100,
  hardcover_book_size: 100,
  gallery_frame_size: 100,
  instagram_frame_size: 100,
  mat_size: 100,
  matrefill_size: 100,
  frame_size: 100,
  print_size: 100,
  softcover_book_size: 100,
  tabletop_frame_size: 100,
  wood_ledge_size: 100,
  wooden_box_size: 100,
  fabric_color: 90,
  frame_finish: 90,
  cover_color: 90,
  page_count: 80,
  pages: 80,
  standard_page_count: 80,
  print_quantity: 80,
  piece_count: 80,
  printing_style: 70,
  frame_type: 70,
  print_border: 60,
  foil_color: 50,
  leather_color: 50,
  print_color: 50,
  paper_type: 40,
  paper: 40,
  refill_calendar_design: 30,
  walnut_calendar_design: 30,
  wood_box_design: 30,
  wood_calendar_design: 30,
  brass_calendar_design: 30,
  envelope_seal_design: 30,
  cover_material: 25,
  dust_jacket: 21,
  envelope: 20,
  envelope_addressing: 10,
  complete_your_set: 5
};
